const getdealerid = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_BACKEND_SERVER}/getexdealer/${id}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    if (!data || !data.custid) {
      throw new Error('No custid found');
    }
    console.log(data.custid);
    return data.custid;
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
};

export default getdealerid;
